import { useMutation } from '@tanstack/react-query';
import { useServices } from '@/contexts/app-services';
import {
  prepareCheckInResponseCreates,
  type CheckInResponseCreateInput,
} from '@/entities/check-in-response';

interface UpsertCheckInResponsesArgs {
  planId: string;
  responses: CheckInResponseCreateInput;
}

export function useUpsertCheckInResponses() {
  const { api } = useServices();

  return useMutation({
    mutationFn: async ({ planId, responses }: UpsertCheckInResponsesArgs) => {
      const prepared = prepareCheckInResponseCreates(planId, responses);
      await api.checkInResponses.upsertCheckInResponses(prepared);
    },
  });
}
